export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            联系我们
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mb-8 leading-relaxed">
            如果你有好的影视资源推荐、观影心得想分享，或者在使用过程中遇到任何问题，欢迎随时通过以下方式与我们联系。被窝网电影团队期待你的声音，一起打造更好的免费高清观影社区。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="#faq"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-medium rounded-lg hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer text-sm"
            >
              <i className="ri-mail-send-line text-lg"></i>
              资源投稿
            </a>
            <a
              href="#faq"
              className="inline-flex items-center gap-2 px-6 py-3 border border-background-300 text-foreground-700 font-medium rounded-lg hover:bg-background-50 hover:border-primary-300 transition-colors duration-200 whitespace-nowrap cursor-pointer text-sm"
            >
              <i className="ri-question-answer-line text-lg"></i>
              常见问题
            </a>
          </div>
          <div className="mt-8 flex flex-wrap items-center justify-center gap-6 text-sm text-foreground-500">
            <span className="flex items-center gap-1.5">
              <i className="ri-time-line"></i>
              工作日 9:00-18:00
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-shield-check-line"></i>
              安全观影承诺
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}